module.exports = __webpack_public_path__ + "static/media/kitchen-134.2beca2e9.jpg";